import { logger } from "../lib/logger";
// Placeholder use-toast hook for core package
// This should be replaced with the actual toast implementation
export function useToast() {
  return {
    toast: (options: { title?: string; description?: string; variant?: string } | string) => {
      if (typeof options === 'string') {
        logger.info(options);
      } else {
        logger.info(`${options.title || 'Toast'}: ${options.description || ''}`);
      }
    },
  };
}

// Direct toast function for services
export function toast(options: { title?: string; description?: string; variant?: string } | string) {
  if (typeof options === 'string') {
    logger.info(options);
  } else {
    logger.info(`${options.title || 'Toast'}: ${options.description || ''}`);
  }
}
